module.exports = __webpack_public_path__ + "img/ico_feed_luckofferreward@3x.63801fd8.png";